import React from 'react'
import { Label } from 'react-bootstrap'

/**
 * Display a room along with it's cleanliness state.
 */
export function renderRoom (room) {
  let cleanStatus = room.isClean ? (
    <Label bsStyle='success'>Clean</Label>
  ) : (
    <Label bsStyle='warning'>Dirty</Label>
  )
  return (
    <span>
      {room.name} {cleanStatus}
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/formatters/roomFormatter.js